module.exports = __webpack_public_path__ + "static/media/zapai.0a24b076.png";